import { computed } from 'vue';
import { useUserStore } from '@/store/userStore';

export function useRoleCheck() {
  const userStore = useUserStore();

  const isSuperAdmin = computed(() => userStore.currentOrganization?.role === 'super_admin');
  const isAdmin = computed(
    () =>
      userStore.currentOrganization?.role === 'admin' ||
      userStore.currentOrganization?.role === 'super_admin'
  );
  const isMember = computed(() => userStore.currentOrganization?.role === 'member');
  const isInstaller = computed(() => userStore.currentOrganization?.role === 'installer');

  // Platform admin = super_admin in ANY membership, regardless of currently
  // selected organization. Mirrors the backend `requirePlatformAdmin`
  // middleware which checks all of a user's user_organizations rows.
  const isPlatformAdmin = computed(() => {
    if (isSuperAdmin.value) return true;
    const memberships = [
      ...(userStore.organizations || []),
      ...(userStore.userData?.organizationMemberships || []),
      ...(userStore.userData?.organizations || []),
    ];
    return memberships.some((m) => m?.role === 'super_admin');
  });

  const hasRole = (roles) => {
    const userRole = userStore.currentOrganization?.role;
    return Array.isArray(roles) ? roles.includes(userRole) : roles === userRole;
  };

  return {
    isSuperAdmin,
    isAdmin,
    isMember,
    isInstaller,
    isPlatformAdmin,
    hasRole,
  };
}
